import styles from "../styles.module.css";
import { ReactComponent as RowInfoSvg } from "../../../../assets/rowInfo.svg";
import { ReactComponent as InfoDotSvg } from "../../../../assets/infodot.svg";
import { ReactComponent as InfoDotGreenSvg } from "../../../../assets/infodotgreen.svg";
import { ReactComponent as InfoDotDangerSvg } from "../../../../assets/infodotdanger.svg";
import { ReactComponent as NoRecordSvg } from "../../../../assets/norecord.svg";
import { ReactComponent as Avatar1 } from "../../../../assets/avatar1.svg";
import { ReactComponent as Avatar2 } from "../../../../assets/avatar2.svg";
import { ReactComponent as Avatar3 } from "../../../../assets/avatar3.svg";
import { ReactComponent as Avatar4 } from "../../../../assets/avatar4.svg";
import { useNavigate } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { IVendorUsers, UpdateUserRole } from "../../../../app/models/user";

interface Props {
  userList: IVendorUsers[];
  updateUserRole: (creds: UpdateUserRole) => Promise<void>;
  rolesLoading: string;
}

const AllUsers = ({ userList, updateUserRole, rolesLoading }: Props) => {
  const navigate = useNavigate();
  return (
    <div>
      {userList.length > 0 ? (
        userList.map((user, index) => {
          return (
            <div key={index} className={styles.userBoxWrapper}>
              <div className={styles.userBox}>
                <div className={styles.avatar}>
                  {user.roleName === "Owner" && <Avatar1 />}
                  {user.roleName === "Admin Manager" && <Avatar1 />}
                  {user.roleName === "Accountant" && <Avatar2 />}
                  {user.roleName === "Store Manager" && <Avatar3 />}
                  {user.roleName === "Store Cashier" && <Avatar4 />}
                </div>
                <div className={styles.userInfo}>
                  <div className={styles.name}>{user.name} {user.lastName}</div>
                  <div className={styles.contact}>
                    <div className={styles.mail}>{user.email} </div>
                    <div className={styles.number}>
                      <InfoDotSvg />
                      {user.phoneNumber}
                    </div>
                  </div>
                </div>
                <div className={styles.roleButton}>
                  <div>{user.roleName}</div>
                </div>
                <div className={styles.details}>
                  <div className={styles.detailsDate}>
                    Created On: {user.dateCreated}{" "}
                  </div>
                  <div className={styles.detailsStatus}>
                    <div
                      className={`${
                        (user.status === "Active" ||
                          user.status === "active") &&
                        styles.active
                      } ${
                        (user.status.includes("inactive") ||
                          user.status.includes("Inactive")) &&
                        styles.inactive
                      }`}
                    >
                      {" "}
                      {user.status === "Active" || user.status === "active" ? (
                        <InfoDotGreenSvg />
                      ) : (
                        <InfoDotDangerSvg />
                      )}
                      {user.status === "Active" || user.status === "active"
                        ? "Active"
                        : "Inactive"}
                    </div>
                  </div>
                </div>
                <div className={styles.infoIcon}>
                  {rolesLoading !== "loading" && user.roleName !== "Owner" && (
                    <Popup
                      trigger={<RowInfoSvg />}
                      content={
                        <div className={styles.menu}>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(user.storeUserId)}
                          >
                            View User Profile
                          </div>
                          <hr />
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              updateUserRole({
                                storeUserId: user.storeUserId,
                                status:
                                  user.status === "Active" ||
                                  user.status === "active"
                                    ? "Inactive"
                                    : "Active",
                              })
                            }
                          >
                            {user.status === "Active" ||
                            user.status === "active"
                              ? "Deactivate"
                              : "Activate"}
                          </div>
                        </div>
                      }
                      on="click"
                      position="bottom center"
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className={styles.norecord}>
          <NoRecordSvg />
        </div>
      )}
    </div>
  );
};

export default observer(AllUsers);
